import { useTranslation } from "react-i18next";
import Button from "../../components/ui/Buttons/Button";
import useAuth from "../../utils/hooks/useAuth";

export default function NoCompanyAccess() {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <section className="w-full max-w-lg rounded-lg bg-white p-6 text-center shadow-sm sm:p-10">
        <h1 className="mb-3 text-2xl font-semibold text-indicafixpurple-700">
          {t("company.access.unavailable.title")}
        </h1>
        <p className="mb-6 text-gray-600">
          {t("company.access.unavailable.description")}
        </p>
        <p className="mb-8 text-sm text-gray-500">
          {t("company.access.unavailable.invitation")}
        </p>
        <Button variant="solid" onClick={() => void signOut()}>
          {t("logout")}
        </Button>
      </section>
    </main>
  );
}
